import React from 'react'
import { Grid, Typography } from '@the-platform-group/component-library'
import { Loader } from '@the-platform-group/component-library/Loader'
import { useQuery } from 'react-query'
import { useNotification } from 'components/Notification'
import { getRawSummaryData } from 'services/assistantSummaries'

const RawDataView = ({
  selectedEntityId,
  selectedCustomer,
  selectedSecurity,
  selectedEntityType,
  selectedDataSource,
}) => {
  const { createNotification } = useNotification()
  const { data: rawSummaryData, isLoading: rawSummaryDataIsLoading } = useQuery(
    [
      'rawSummaryData',
      {
        entityId: selectedEntityId,
        customerId: selectedCustomer?.id,
        securityId: selectedSecurity?.id,
        entityType: selectedEntityType,
        dataSource: selectedDataSource,
      },
    ],
    getRawSummaryData,
    {
      onError: error =>
        createNotification({
          message: error.response?.data?.error || error.message,
          variant: 'error',
        }),
      enabled: Boolean(
        selectedEntityId && selectedCustomer && selectedSecurity?.id && selectedEntityType,
      ),
      refetchOnWindowFocus: false,
      useErrorBoundary: false,
    },
  )

  return (
    <Grid
      container
      sx={{
        height: '100%',
      }}
      justifyContent="flex-start"
      direction="column"
      rowGap={2}
    >
      {rawSummaryDataIsLoading ? (
        <Loader />
      ) : (
        <>
          <Grid item container direction="column">
            <Grid item>
              <Typography variant="h6">Raw Data Used</Typography>
            </Grid>
            <Grid item>
              <Typography variant="caption">
                Total raw data records used: {rawSummaryData?.count || 0}
              </Typography>
            </Grid>
          </Grid>

          <Grid item container>
            <Typography sx={{ whiteSpace: 'pre-line' }} variant="body2">
              {rawSummaryData?.rawData}
            </Typography>
          </Grid>
        </>
      )}
    </Grid>
  )
}

export default RawDataView
